const currencies = [
    { symbol: "USD", name: "US Dollar", country: "US" },
    { symbol: "GBP", name: "Pound Sterling", country: "GB" },
    { symbol: "AUD", name: "Australian Dollar", country: "AU" },
    { symbol: "CAD", name: "Canadian Dollar", country: "CA" },
    { symbol: "MXN", name: "Mexican Peso", country: "MX" },
    { symbol: "NZD", name: "New Zealand Dollar", country: "NZ" },
    { symbol: "EGP", name: "Egyptian Pound", country: "EG" },
    { symbol: "ZAR", name: "South African Rand", country: "ZA" },
    { symbol: "CHF", name: "Swiss Franc", country: "CH,LI" },
    { symbol: "EUR", name: "Euro", country: "AT,BE,HR,CY,EE,FI,FR,DE,GR,IE,IT,LV,LT,LU,MT,NL,PT,SK,SI,ES" },
    { symbol: "JPY", name: "Japanese Yen", country: "JP" },
]

export default currencies;
